import { render, staticRenderFns } from "./SelectPriceScheme.vue?vue&type=template&id=4ee5506a&"
import script from "./SelectPriceScheme.vue?vue&type=script&lang=js&"
export * from "./SelectPriceScheme.vue?vue&type=script&lang=js&"
import style0 from "./SelectPriceScheme.vue?vue&type=style&index=0&id=4ee5506a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports